/* =====================================================
   LAMPEMAGASINET - KAMPANJE: HANDLE FOR X – FÅ Y %
   Markup: snippets/lm-campaign-block.liquid  ·  CSS: lm-campaign-progress.css

   Hvordan oppdateringer fanges opp (uten egne nettverkskall / polling):
   Temaet har ingen egne cart-events, men ALLE måter å endre handlekurven
   på (produktside, handlekurv-skuff, handlekurvside, mersalg, pære-
   anbefalinger, pakkebygger, Swym-ønskeliste via custom_script) re-
   rendrer allerede seksjonen "cart-icon-bubble" fra serveren. Den
   seksjonen inneholder en skjult markør med kampanjeverdien
   (data-lm-cp-data). En MutationObserver på handlekurv-ikonet leser ny
   verdi idet temaet setter inn ny HTML – samme respons, null ekstra kall.

   Kort i handlekurv-skuffen og på handlekurvsiden rendres ferdig fra
   serveren; her animeres bare fremdriftslinjen fra forrige verdi.
   Den flytende indikatoren og produktsidelinjen oppdateres her.
   ===================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('lm-cp-config');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var THRESHOLD = Number(cfg.threshold) || 0;
  if (THRESHOLD <= 0) return;

  var NBSP = ' ';
  var TOKEN_RE = /\[(threshold|percent|remaining|total)\]/g;
  var texts = cfg.texts || {};
  var value = Number(cfg.value) || 0;

  var floatEl = document.querySelector('[data-lm-cp-float]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Beregning / formatering ---------- */

  // Samme format som snippets/lm-campaign-money.liquid: "2 000 kr"
  function formatKr(cents, ceil) {
    var kr = cents / 100;
    kr = ceil ? Math.ceil(kr) : Math.floor(kr);
    if (kr < 0) kr = 0;
    return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + NBSP + 'kr';
  }

  function formatPercent() {
    return String(cfg.percent).replace('.', ',') + NBSP + '%';
  }

  function stageFor(v) {
    if (v <= 0) return 'empty';
    if (v >= THRESHOLD) return 'reached';
    return 'progress';
  }

  // Alltid 0–1: linjen kan aldri visuelt gå over 100 %
  function ratioFor(v) {
    var r = v / THRESHOLD;
    if (!(r > 0)) return 0;
    return Math.round(Math.min(r, 1) * 10000) / 10000;
  }

  function tokensFor(v) {
    return {
      threshold: formatKr(THRESHOLD),
      percent: formatPercent(),
      remaining: formatKr(THRESHOLD - v, true),
      total: formatKr(v)
    };
  }

  // Bygger tekst med uthevede beløp – via DOM-noder, aldri innerHTML
  function fillText(el, template, tokens) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    if (!template) return;
    var last = 0;
    template.replace(TOKEN_RE, function (match, key, index) {
      if (index > last) el.appendChild(document.createTextNode(template.slice(last, index)));
      var strong = document.createElement('strong');
      strong.textContent = tokens[key];
      el.appendChild(strong);
      last = index + match.length;
      return match;
    });
    if (last < template.length) el.appendChild(document.createTextNode(template.slice(last)));
  }

  function titleFor(stage) {
    return texts[stage] || '';
  }

  function subFor(stage) {
    return texts[stage + 'Sub'] || '';
  }

  function setBar(root, ratio) {
    var bar = root.querySelector('[data-lm-cp-bar]');
    var fill = root.querySelector('[data-lm-cp-fill]');
    if (fill) {
      fill.style.setProperty('--lm-cp-p', ratio);
      fill.setAttribute('data-p', ratio);
    }
    if (bar) bar.setAttribute('aria-valuenow', Math.round(ratio * 100));
  }

  /* ---------- Rendering av JS-styrte visninger ---------- */

  function renderFloat(v) {
    if (!floatEl) return;
    var stage = stageFor(v);
    var tokens = tokensFor(v);
    floatEl.setAttribute('data-stage', stage);
    if (stage !== 'empty') closePop(false);
    fillText(floatEl.querySelector('[data-lm-cp-title]'), titleFor(stage), tokens);
    fillText(floatEl.querySelector('[data-lm-cp-sub]'), subFor(stage), tokens);
    var ratio = ratioFor(v);
    setBar(floatEl, ratio);
    var mini = floatEl.querySelector('.lm-cp-float__mini');
    if (mini) mini.style.setProperty('--lm-cp-p', ratio);
  }

  function renderProducts(v) {
    var stage = stageFor(v);
    var tokens = tokensFor(v);
    var remaining = THRESHOLD - v;
    document.querySelectorAll('[data-lm-cp-product]').forEach(function (el) {
      var price = Number(el.getAttribute('data-price')) || 0;
      var title = titleFor(stage);
      if (stage !== 'reached' && price >= remaining && texts.productUnlock) {
        title = texts.productUnlock;
      }
      el.setAttribute('data-stage', stage);
      fillText(el.querySelector('[data-lm-cp-title]'), title, tokens);
      setBar(el, ratioFor(v));
    });
  }

  /* ---------- Flytende indikator: tilstand og oppførsel ---------- */

  var collapseTimer = null;

  function expand(ms) {
    if (!floatEl) return;
    floatEl.classList.add('is-expanded');
    clearTimeout(collapseTimer);
    if (ms) collapseTimer = setTimeout(collapse, ms);
  }

  function collapse() {
    if (!floatEl || floatEl.contains(document.activeElement)) return;
    floatEl.classList.remove('is-expanded');
  }

  /* Forklaring ved tom handlekurv: liten boble over kortet. Åpnes ved klikk
     på indikatoren – bare når handlekurven er helt tom. Lukkes med ×,
     Escape, klikk utenfor, minimering, eller idet første vare legges i. */
  var popEl = floatEl ? floatEl.querySelector('[data-lm-cp-pop]') : null;

  function onPopKey(event) {
    if (event.key === 'Escape') closePop(true);
  }

  function onPopPointer(event) {
    if (!floatEl.contains(event.target)) closePop(false);
  }

  function openPop() {
    if (!popEl || !popEl.hidden) return;
    popEl.hidden = false;
    floatEl.classList.add('is-pop-open');
    document.addEventListener('keydown', onPopKey);
    document.addEventListener('pointerdown', onPopPointer);
    var closeBtn = popEl.querySelector('[data-lm-cp-pop-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closePop(restoreFocus) {
    if (!popEl || popEl.hidden) return;
    popEl.hidden = true;
    floatEl.classList.remove('is-pop-open');
    document.removeEventListener('keydown', onPopKey);
    document.removeEventListener('pointerdown', onPopPointer);
    if (restoreFocus) {
      var main = floatEl.querySelector('[data-lm-cp-open]');
      if (main) main.focus({ preventScroll: true });
    }
  }

  function replayClass(el, cls, ms) {
    if (!el || reduceMotion.matches) return;
    el.classList.remove(cls);
    void el.offsetWidth; // start animasjonen på nytt
    el.classList.add(cls);
    setTimeout(function () {
      el.classList.remove(cls);
    }, ms);
  }

  function storage(action, key, val) {
    try {
      if (action === 'get') return sessionStorage.getItem(key);
      if (action === 'set') sessionStorage.setItem(key, val);
      if (action === 'remove') sessionStorage.removeItem(key);
    } catch (e) {
      return null;
    }
    return null;
  }

  function initFloat() {
    if (!floatEl) return;

    // Første møte i økten: tydelig og utvidet – deretter kompakt
    if (!storage('get', 'lmCpSeen')) {
      storage('set', 'lmCpSeen', '1');
      if (!floatEl.classList.contains('is-mini')) {
        floatEl.classList.add('is-intro');
        expand(9000);
        var onScroll = function () {
          if (window.scrollY > 400) {
            window.removeEventListener('scroll', onScroll);
            clearTimeout(collapseTimer);
            collapse();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }

    floatEl.addEventListener('focusout', function () {
      collapseTimer = setTimeout(collapse, 400);
    });

    var main = floatEl.querySelector('[data-lm-cp-open]');
    var minBtn = floatEl.querySelector('[data-lm-cp-min]');
    var restoreBtn = floatEl.querySelector('[data-lm-cp-restore]');

    if (main) {
      main.addEventListener('click', function () {
        var stage = stageFor(value);
        var href = main.getAttribute('data-href');
        if (stage === 'empty') {
          if (popEl) {
            popEl.hidden ? openPop() : closePop(false);
            return;
          }
          if (href) {
            window.location.href = href;
          } else {
            floatEl.classList.contains('is-expanded') ? floatEl.classList.remove('is-expanded') : expand(8000);
          }
          return;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(main);
        } else {
          window.location.href = cfg.cartUrl || '/cart';
        }
      });
    }

    if (minBtn) {
      minBtn.addEventListener('click', function () {
        closePop(false);
        floatEl.classList.add('is-mini');
        floatEl.classList.remove('is-expanded');
        storage('set', 'lmCpMini', '1');
        if (restoreBtn) restoreBtn.focus();
      });
    }

    var popClose = popEl ? popEl.querySelector('[data-lm-cp-pop-close]') : null;
    if (popClose) {
      popClose.addEventListener('click', function () {
        closePop(true);
      });
    }

    if (restoreBtn) {
      restoreBtn.addEventListener('click', function () {
        floatEl.classList.remove('is-mini');
        storage('remove', 'lmCpMini');
        expand(6000);
        if (main) main.focus();
      });
    }
  }

  /* ---------- Oppdatering når handlekurven endres ---------- */

  var pendingVisible = null;

  function floatHidden() {
    return !!floatEl && getComputedStyle(floatEl).visibility === 'hidden';
  }

  function whenFloatVisible(callback) {
    if (!floatHidden()) {
      callback();
      return;
    }
    // Kun siste oppdatering teller; én midlertidig observer på klasse-endringer
    if (pendingVisible) {
      pendingVisible.callback = callback;
      return;
    }
    pendingVisible = { callback: callback };
    var mo = new MutationObserver(function () {
      if (floatHidden()) return;
      mo.disconnect();
      var cb = pendingVisible.callback;
      pendingVisible = null;
      // vent til inntoningen er i gang før "dunket"
      setTimeout(cb, 150);
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    mo.observe(floatEl, { attributes: true, attributeFilter: ['class'] });
  }

  function setValue(next, insertedFills) {
    if (next === value && !insertedFills.length) return;
    var prev = value;
    var prevRatio = ratioFor(prev);
    var prevStage = stageFor(prev);
    value = next;
    var stage = stageFor(next);
    var crossed = prevStage !== 'reached' && stage === 'reached';

    // Server-rendrede kort (skuff/handlekurvside): animer linjen fra forrige verdi
    insertedFills.forEach(function (fill) {
      var target = fill.getAttribute('data-p');
      if (reduceMotion.matches || target === null) return;
      fill.style.transition = 'none';
      fill.style.setProperty('--lm-cp-p', prevRatio);
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.setProperty('--lm-cp-p', target);
      if (crossed) {
        var card = fill.closest('.lm-cp');
        if (card) replayClass(card, 'is-celebrate', 800);
      }
    });

    if (next === prev) return;

    renderFloat(next);
    renderProducts(next);

    if (floatEl) {
      // Er skuffen/en popup åpen, er indikatoren skjult – vis endringen i det
      // kunden lukker den og fortsetter å handle.
      whenFloatVisible(function () {
        if (crossed) replayClass(floatEl, 'is-celebrate', 800);
        replayClass(floatEl, 'is-bump', 600);
        if (!floatEl.classList.contains('is-mini')) expand(crossed ? 7000 : 5000);
      });
    }

    document.dispatchEvent(new CustomEvent('lm:campaign:update', {
      detail: { value: next, previous: prev, threshold: THRESHOLD, stage: stage, ratio: ratioFor(next) }
    }));
  }

  function readMarker(root) {
    var marker = root && root.querySelector('[data-lm-cp-data]');
    if (!marker) return null;
    var v = parseInt(marker.getAttribute('data-lm-cp-data'), 10);
    return isNaN(v) ? null : v;
  }

  function onMutations(records) {
    var fills = [];
    var bubbleChanged = false;
    records.forEach(function (record) {
      if (record.target.id === 'cart-icon-bubble' || (record.target.closest && record.target.closest('#cart-icon-bubble'))) {
        bubbleChanged = true;
      }
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-lm-cp-fill]')) fills.push(node);
        node.querySelectorAll('.lm-cp [data-lm-cp-fill]').forEach(function (f) {
          if (fills.indexOf(f) === -1) fills.push(f);
        });
      });
    });

    var next = bubbleChanged ? readMarker(document.getElementById('cart-icon-bubble')) : null;
    if (next === null) next = value; // ingen ny markør: verdien er uendret
    setValue(next, fills);
  }

  function observe() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(onMutations);
    ['#cart-icon-bubble', 'cart-drawer', '#main-cart-items'].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }

  // Tilbake-knapp (bfcache): siden vises fra minnet med gammel handlekurv –
  // hent kun handlekurv-ikonets seksjon én gang og les verdien derfra.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    fetch((cfg.root || '/') + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var next = readMarker(doc);
        if (next !== null) setValue(next, []);
      })
      .catch(function () {});
  });

  function init() {
    initFloat();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
